<template>
  <div class="container-fluid">
    <input v-if="galleryOptions !== null" v-file-uploader="galleryOptions" type="file" name="files" class="gallery_media" />
  </div>
</template>

<script>
import VueFileUploader from "@/directives/VueFileUploader.js";
export default {
  name: "VenueImages",
  components: {},
  directives: {
    VueFileUploader
  },
  props: ['venue', 'venueId'],
  data() {
    return {
      galleryOptions: null
    };
  },
  mounted() {
    const files = this.venue.imageUrls.map(imageUrl => (
      {
        name: 'venue.jpg',
        size: 1,
        type: 'image/jpg',
        file: imageUrl,
        data: {
          url: imageUrl
        }
      }
    ));

    this.galleryOptions = {
      deletingImage: false,
      uploadUrl: process.env.VUE_APP_API_BASE_URL +'/VenueImages/' + this.venueId,
      deleteUrl: process.env.VUE_APP_API_BASE_URL +'/VenueImages/' + this.venueId,
      sortUrl: process.env.VUE_APP_API_BASE_URL +'/VenueImages/' + this.venueId,
      files: files
    };
  },
  beforeDestroy: function() {
  },
  methods: {}
};
</script>